import { PayloadAction } from '@reduxjs/toolkit';

import { IBuyBarState, IMobileBuyBarView, IVariantGridView } from 'store/types/buyBarTypes';
import { IPriceLocalized } from 'shared/types/Price';
import { ISize } from 'shared/types/Size';
import { ISizesMap, IVariant } from 'productTemplate/types/SizesMap';

export const setBuyNewAndBuyUsedVariants = (
  state: IBuyBarState,
  action: PayloadAction<{ buyNewVariant: IVariant; buyUsedVariant: IVariant }>,
) => {
  const { buyNewVariant, buyUsedVariant } = action.payload;

  state.buyNewVariant = buyNewVariant;
  state.buyUsedVariant = buyUsedVariant;
};

export const setMobileBuyBarView = (
  state: IBuyBarState,
  action: PayloadAction<IMobileBuyBarView>,
) => {
  state.mobileBuyBarView = action.payload;
};

export const setBuyBarSizesMap = (state: IBuyBarState, action: PayloadAction<ISizesMap>) => {
  state.buyBarSizesMap = action.payload;
};

export const setMakeOfferVariant = (
  state: IBuyBarState,
  action: PayloadAction<{
    topOffer?: IPriceLocalized;
    lastSold?: IPriceLocalized;
    sizeOption: ISize;
  }>,
) => {
  state.makeOfferVariant = action.payload;
};

export const setOffersMap = (
  state: IBuyBarState,
  action: PayloadAction<{
    [key: string]: {
      topOffer?: IPriceLocalized;
      lastSold?: IPriceLocalized;
      sizeOption: ISize;
    };
  }>,
) => {
  state.offersMap = action.payload;
};

export const setExpandedSize = (state: IBuyBarState, action: PayloadAction<string>) => {
  state.expandedSize = action.payload;
};

export const setVariantGridView = (
  state: IBuyBarState,
  action: PayloadAction<IVariantGridView>,
) => {
  state.variantGridView = action.payload;
};

export const setIsVariantDetailedViewOpen = (
  state: IBuyBarState,
  action: PayloadAction<{ isVariantDetailedViewOpen: boolean; variantGridView?: IVariantGridView }>,
) => {
  const { isVariantDetailedViewOpen, variantGridView } = action.payload;
  state.isVariantDetailedViewOpen = isVariantDetailedViewOpen;

  if (variantGridView) {
    state.variantGridView = variantGridView;
  }
};
